// window.$ = window.jQuery = require('jquery');

require('./common/utmTracking');
require('./common/recaptchav3');
require('./common/currentLocale');
require('./components/header-select-lang');
require('./components/accordion');
require('./components/tabs');
require('./components/header');
require('./components/search');
require('./components/big-text');
require('./components/lazy-video');

const { setFontSize, setContrast, toggleAcessibilityBox } = require('./common/accessibility');
window.setFontSize = setFontSize;
window.setContrast = setContrast;
window.toggleAcessibilityBox = toggleAcessibilityBox;

const { domContentLoadEvent } = require('./common/domContentLoadEvent');
domContentLoadEvent(function () {
    var bodyElement = document.querySelector('body');
    setTimeout(function () {
        bodyElement.classList.add('loaded');
    }, 500);
});
